<!--
 * @Description  :
 * @Version      : 2.0
 * @Autor        : fangzheng
 * @Date         : 2021-09-03 14:29:48
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-31 16:01:17
-->
<template>
  <div>
    <div class="text-contion" v-for="(item, index) in coReqVos" :key="index">
      <el-button
        v-if="index === 0 && !disabled"
        class="btn"
        type="danger"
        icon="el-icon-plus"
        size="mini"
        circle
        @click="addBtn"
      ></el-button>
      <el-button
        v-if="index !== 0 && !disabled"
        class="btn"
        type="danger"
        icon="el-icon-minus"
        size="mini"
        circle
        @click="deleteBtn(index)"
      ></el-button>
      <el-form ref="item" :model="item" label-width="125px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="需结转组织">
              <div
                class="cost-select"
                @click="openHandleClick('org', 'org_list1', 'orgCode', index)"
              >
                <div
                  class="cost-select1 el-textarea el-input--small"
                  style="min-height: 32px"
                >
                  <el-tag
                    class="tag_box"
                    v-for="(item1, index1) in item.orgReqVos"
                    :key="index1"
                    closable
                    @close="handleClose(item1, index)"
                    >{{ item1.orgName }}</el-tag
                  >
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转结财年">
              <el-select
                v-model="item.coBudgetYear"
                multiple
                placeholder="转结财年"
              >
                <el-option
                  v-for="item in fiscalYearArrList"
                  :key="item.dictCode"
                  :label="item.dictValue"
                  :value="item.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调出结转类型">
              <el-select
                v-model="item.transferOutCarryType"
                placeholder="调出结转类型"
                @change="(e)=>typeChange(e,'transferOutCarryType',index)"
              >
                <el-option
                  v-for="dictItem in transferOutCarryTypeList"
                  :key="dictItem.dictCode"
                  :label="dictItem.dictValue"
                  :value="dictItem.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="item.transferOutCarryType === 'specified_series'">
            <el-form-item label="调出结转系列">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'transferOutCarrySeries',
                    '',
                    '',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.transferOutCarrySeriesName"
                  placeholder="调出结转系列"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'transferOutCarrySeries', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转结预算科目">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'budget',
                    'budget_list',
                    'budgetSubjectsCode',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.coBudgetSubjectName"
                  placeholder="转结预算科目"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'budget', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-row> </el-row>
          <el-col :span="24">
            <el-form-item label="转结公司主体">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'company',
                    'company_list',
                    'companyCode',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.coCompanyName"
                  placeholder="转结公司主体"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'company', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转入组织">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'unionOrg',
                    'org_list2',
                    'orgCode',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.unionOrgName"
                  placeholder="转入组织"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'unionOrg', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="调入结转类型">
              <el-select
                v-model="item.transferInCarryType"
                placeholder="调入结转类型"
                @change="(e)=>typeChange(e,'transferInCarryType',index)"
              >
                <el-option
                  v-for="dictItem in transferInCarryTypeList"
                  :key="dictItem.dictCode"
                  :label="dictItem.dictValue"
                  :value="dictItem.dictCode"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="item.transferInCarryType === 'specified_series'">
            <el-form-item label="调入结转系列">
              <div
                class="cost-select"
                @click="
                  openHandleClick(
                    'transferInCarrySeries',
                    '',
                    '',
                    index
                  )
                "
              >
                <el-input
                  :readonly="true"
                  v-model="item.transferInCarrySeriesName"
                  placeholder="调入结转系列"
                ></el-input>
                <div class="clear-icon" v-if="!disabled">
                  <i
                    class="el-icon-circle-close"
                    @click="clearFn($event, 'transferInCarrySeries', index)"
                  ></i>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';
import request from '../../../../../../utils/request';

export default {
  components: {
    SelectConfig,
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.coReqVos = val;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      fiscalYearArrList: [],
      transferOutCarryTypeList: [],
      transferInCarryTypeList: [],
      coReqVos: [{}],
      index: null,
      chooseModule: null,
    };
  },
  props: {
    value: Array,
    disabled: Boolean,
  },
  created() {
    this.getyesOrNoData();
    this.getTransferOutCarryTypeData();
    this.getTransferInCarryTypeData();
  },
  mounted() {},
  methods: {
    // 打开点击弹窗
    openHandleClick(module, list, key, index, requestType = 'POST') {
      if (this.disabled) {
        return;
      }
      this.index = index;
      this.chooseModule = module;
      let params = {};
      if (module === 'org') {
        params = {
          functionCode: list,
          data: this.coReqVos[index].orgReqVos,
          idKey: 'orgCode',
          paramData: {
            enableStatus: '009',
          },
          requestType,
          noReset: true,
        };
      } else if (module === 'budget') {
        params = {
          functionCode: list,
          data: [],
          idKey: 'id',
          paramData: {},
          requestType,
        };
      } else if (module === 'company') {
        params = {
          functionCode: list,
          data: [],
          idKey: 'id',
          paramData: {},
          requestType,
        };
      } else if (module === 'unionOrg') {
        params = {
          functionCode: list,
          data: [],
          idKey: 'id',
          paramData: {
            enableStatus: '009',
          },
          requestType,
        };
      } else if (module === 'transferOutCarrySeries' || module === 'transferInCarrySeries') {
        let data = [];
        if (module === 'transferOutCarrySeries') {
          const array = this.coReqVos[index].transferOutCarrySeriesCode ? this.coReqVos[index].transferOutCarrySeriesCode.split(',') : [];
          data = array.map((item, tIndex) => ({
            productLevelName: this.coReqVos[index].transferOutCarrySeriesName.split(',')[tIndex],
            productLevelCode: item,
          }));
        } else {
          const array = this.coReqVos[index].transferInCarrySeriesCode ? this.coReqVos[index].transferInCarrySeriesCode.split(',') : [];
          data = array.map((item, tIndex) => ({
            productLevelName: this.coReqVos[index].transferInCarrySeriesName.split(',')[tIndex],
            productLevelCode: item,
          }));
        }
        params = {
          functionCode: 'series-list',
          data,
          idKey: 'productLevelCode',
          paramData: {
            enableStatus: '009',
            delFlag: '009',
          },
          requestType,
        };
        console.log(params);
      } else {
        params = {
          functionCode: list,
          data: [],
          idKey: key,
          paramData,
          requestType,
        };
      }
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 获取弹窗选中数据
    onGetSelect(data) {
      const { index } = this;
      console.log(data, this.chooseModule);
      if (this.chooseModule === 'org') {
        let dataList = data;
        dataList = dataList.map((v) => {
          const obj = v;
          return {
            orgCode: obj.orgCode,
            orgName: obj.orgName,
          };
        });
        this.coReqVos[index].orgReqVos = dataList;
      } else if (this.chooseModule === 'budget') {
        if (data.length > 0) {
          this.coReqVos[index].coBudgetSubjectName = data[0].budgetSubjectsName; // 组织编码
          this.coReqVos[index].coBudgetSubjectCode = data[0].budgetSubjectsCode; // 组织名称
        } else {
          this.coReqVos[index].coBudgetSubjectName = null;
          this.coReqVos[index].coBudgetSubjectCode = null;
        }
      } else if (this.chooseModule === 'company') {
        if (data.length > 0) {
          this.coReqVos[index].coCompanyName = data[0].companyName; // 组织编码
          this.coReqVos[index].coCompanyCode = data[0].companyCode; // 组织名称
        } else {
          this.coReqVos[index].coCompanyName = null;
          this.coReqVos[index].coCompanyCode = null;
        }
      } else if (this.chooseModule === 'unionOrg') {
        if (data.length > 0) {
          this.coReqVos[index].unionOrgName = data[0].orgName; // 组织编码
          this.coReqVos[index].unionOrgCode = data[0].orgCode; // 组织名称
        } else {
          this.coReqVos[index].unionOrgName = null;
          this.coReqVos[index].unionOrgCode = null;
        }
      } else if (this.chooseModule === 'transferOutCarrySeries') {
        if (data.length > 0) {
          this.$set(this.coReqVos[index], 'transferOutCarrySeriesName', data.map((v) => v.productLevelName).join(','));
          this.$set(this.coReqVos[index], 'transferOutCarrySeriesCode', data.map((v) => v.productLevelCode).join(','));
        } else {
          this.$set(this.coReqVos[index], 'transferOutCarrySeriesName', null);
          this.$set(this.coReqVos[index], 'transferOutCarrySeriesCode', null);
        }
      } else if (this.chooseModule === 'transferInCarrySeries') {
        if (data.length > 0) {
          this.$set(this.coReqVos[index], 'transferInCarrySeriesName', data.map((v) => v.productLevelName).join(','));
          this.$set(this.coReqVos[index], 'transferInCarrySeriesCode', data.map((v) => v.productLevelCode).join(','));
        } else {
          this.$set(this.coReqVos[index], 'transferInCarrySeriesName', null);
          this.$set(this.coReqVos[index], 'transferInCarrySeriesCode', null);
        }
      }
      this.$emit('input', this.coReqVos);
    },
    // 清除数据
    clearFn(e, code, index) {
      e.stopPropagation();
      if (code === 'org') {
        this.coReqVos[index].orgReqVos = [];
      } else if (code === 'budget') {
        this.coReqVos[index].coBudgetSubjectName = null;
        this.coReqVos[index].coBudgetSubjectCode = null;
      } else if (code === 'company') {
        this.coReqVos[index].coCompanyName = null;
        this.coReqVos[index].coCompanyCode = null;
      } else if (code === 'unionOrg') {
        this.coReqVos[index].unionOrgName = null;
        this.coReqVos[index].unionOrgCode = null;
      } else if (code === 'transferOutCarrySeries') {
        this.$set(this.coReqVos[index], 'transferOutCarrySeriesName', null);
        this.$set(this.coReqVos[index], 'transferOutCarrySeriesCode', null);
      } else if (code === 'transferInCarrySeries') {
        this.$set(this.coReqVos[index], 'transferInCarrySeriesName', null);
        this.$set(this.coReqVos[index], 'transferInCarrySeriesCode', null);
      }
      this.$emit('input', this.coReqVos);
    },
    handleClose(item1, index) {
      if (this.disabled) {
        return;
      }
      this.coReqVos[index].orgReqVos = this.coReqVos[index].orgReqVos.filter(
        (v) => v.orgCode !== item1.orgCode,
      );
      this.$emit('input', this.coReqVos);
    },
    addBtn() {
      this.coReqVos.push({
        orgReqVos: [],
        coBudgetYear: '',
        transferOutCarryType: '',
        transferOutCarrySeriesName: '',
        transferOutCarrySeriesCode: '',
        coBudgetSubjectName: '',
        coBudgetSubjectCode: '',
        coCompanyName: '',
        coCompanyCode: '',
        unionOrgName: '',
        unionOrgCode: '',
        transferInCarryType: '',
        transferInCarrySeriesName: '',
        transferInCarrySeriesCode: '',
      });
      this.$emit('input', this.coReqVos);
    },
    deleteBtn(index) {
      this.coReqVos.splice(index, 1);
      this.$emit('input', this.coReqVos);
    },
    // 获取转结财年数据字典
    getyesOrNoData() {
      request
        .post('/mdm/mdmdictdata/list', {
          dictTypeCode: 'budget_year',
        })
        .then((res) => {
          if (res.success) {
            this.fiscalYearArrList = res.result;
          }
        });
    },
    // 获取调出结转类型数据字典
    getTransferOutCarryTypeData() {
      request
        .post('/mdm/mdmdictdata/list', {
          dictTypeCode: 'tpm_transfer_out_carry_type',
        })
        .then((res) => {
          if (res.success) {
            this.transferOutCarryTypeList = res.result;
          }
        });
    },
    // 获取调入结转类型数据字典
    getTransferInCarryTypeData() {
      request
        .post('/mdm/mdmdictdata/list', {
          dictTypeCode: 'tpm_transfer_in_carry_type',
        })
        .then((res) => {
          if (res.success) {
            this.transferInCarryTypeList = res.result;
          }
        });
    },

    // 调出结转类型改变时，清空调出结转系列
    typeChange(e, code, index) {
      console.log(e, code, index);
      if (e !== 'specified_series') {
        if (code === 'transferOutCarryType') {
          this.$set(this.coReqVos[index], 'transferOutCarrySeriesName', null);
          this.$set(this.coReqVos[index], 'transferOutCarrySeriesCode', null);
        } else if (code === 'transferInCarryType') {
          this.$set(this.coReqVos[index], 'transferInCarrySeriesName', null);
          this.$set(this.coReqVos[index], 'transferInCarrySeriesCode', null);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form-item__label {
  font-size: 12px !important;
}
.cost-select {
  position: relative;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
.cost-select1 {
  position: relative;
  border: 1px solid #dddfe6;
  border-radius: 5px;
  padding: 5px;

  /deep/ .el-input__inner {
    padding-right: 30px;
  }

  .clear-icon {
    width: 25px;
    height: 100%;
    position: absolute;
    right: 5px;
    top: 0;
    text-align: center;
    color: #c0c4cc;
    transition: all 0.3s;
    padding-top: 1px;
    display: none;

    .el-icon-circle-close {
      width: 100%;
      font-size: 14px;
      cursor: pointer;
      transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    }
  }

  &:hover {
    .clear-icon {
      display: block;
    }
  }
}
.tag_box{
    margin-right: 5px;
}
.btn {
  float: right;
  margin-left: 10px;
}
</style>
